import {useCallback} from 'react';
import {PopupMenu, PopupMenuItem} from 'extensions/viewport/PopupMenu';
import {usePopup} from 'extensions/viewport/usePopup';

export function useMenu(items: () => PopupMenuItem[], onSelect: (command: string) => void, multiMode?: boolean) {
  const popup = usePopup();

  const {exit, visible, reference} = popup;

  const open = useCallback(() => {
    popup.open(
      <PopupMenu
        multiMode={multiMode}
        menuItems={items().filter(e => !!e)}
        onSelectItem={onSelect}
        exit={exit}
      />
    );
  }, [items]);

  return {open, exit, visible, reference};
}
